import { render, staticRenderFns } from "./twitter_instantwin_add_edit.vue?vue&type=template&id=18e00271&scoped=true"
import script from "./twitter_instantwin_add_edit.vue?vue&type=script&lang=ts"
export * from "./twitter_instantwin_add_edit.vue?vue&type=script&lang=ts"
import style0 from "./twitter_instantwin_add_edit.vue?vue&type=style&index=0&id=18e00271&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e00271",
  null
  
)

export default component.exports